import { css } from 'styled-components';

export const accordionHeading = css`
  display: block;
  list-style: none;
  &::-webkit-details-marker {
    display: none;
  }
`;

export const accordionItem = css`
  display: block;
  &:last-of-type {
    border-bottom: 1px solid var(--neutral-black-30);
  }
`;
